<div class="list-end-page-item">
  <mat-divider class="list-end-page-item__divider"></mat-divider>
  <div class="list-end-page-item__container">
    <button mat-list-item class="list-question-item__question" [class.active]="surveyEditorService.endPageScreenActive$()" (click)="onActivate()">
      <div class="list-end-page-item__button">
        <fa-icon class="type-icon" [icon]="faFlagCheckered"></fa-icon>
        "Thank you" Page
      </div>
      @if (surveyEditorService.surveyEditor$().form.get('useEndPageInd').value) {
        <fa-icon matTooltip="Thank you page shown" [color]="'success'" [icon]="faCheckDouble"></fa-icon>
      } @else {
        <fa-icon matTooltip="Thank you page hidden" [color]="'warn'" [icon]="faBan"></fa-icon>
      }
    </button>
  </div>
</div>
